import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";
import { PayrollVocationalEarningsSetup } from "../../components/PayrollVocationalEarningsSetup";

export const PayrollVocationalEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Vacational Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll Vacational Earnings", navigateTo: "/company/payrollVocationalEarnings/setup" }
      ]}
      mainContents={<PayrollVocationalEarningsSetup />}
    />
  );
};
